import { api } from "./api";

export const SEGMENTS = [
  { id: "uhnw", label: "UHNW Earner / Individual" },
  { id: "hnw", label: "HNW Earner / Individual" },
  { id: "family_office", label: "Family / Trust Office" },
  { id: "advisor", label: "Investment Advisor / Wealth Manager" },
  { id: "luxury_brand", label: "Luxury Brand / Marketer" },
  { id: "partner", label: "Partner / Press / Institution" },
  { id: "general", label: "General Reader" },
];

export const TIERS = [
  {
    id: "public",
    label: "Public",
    summary: "Free monthly teaser — Cover Brief only.",
    blurb: "A short preview of each month's central thesis.",
  },
  {
    id: "premium",
    label: "Premium",
    summary: "Full monthly briefing — every pillar, signal, and watch list.",
    blurb: "Market Pulse · Family Office Desk · Luxury Intelligence · Tax Lien Watch · Private Signals.",
  },
  {
    id: "advisor",
    label: "Advisor / Family Office",
    summary: "Private edition — additional notes for fiduciaries & RIAs.",
    blurb: "Curated additions for advisors, family offices, and institutional capital allocators.",
  },
];

export const INTERESTS = [
  "Private markets", "Family-office governance", "Estate planning",
  "Tax strategy", "Tax liens", "Luxury watches", "Jewelry & diamonds",
  "Collectible cars", "Yachting & aviation", "Art & auctions",
  "Hospitality & travel", "Real estate / REITs", "Private equity",
  "Venture capital", "M&A / buyouts", "Macro outlook",
];

export async function subscribeNewsletter(payload) {
  const { data } = await api.post("/newsletter/subscribe", payload);
  return data;
}

export async function listIssues() {
  const { data } = await api.get("/newsletter/issues");
  return data;
}

export async function getIssue(slug, email) {
  const { data } = await api.get(`/newsletter/issues/${slug}`, {
    params: email ? { email } : {},
  });
  return data;
}
